import React from 'react';
import { MdSports, MdSportsSoccer, MdSportsBasketball, MdSportsRugby, MdSportsHockey } from 'react-icons/md';
import { Circle } from 'lucide-react';

const getTeamIcon = (sport) => {
  switch (sport?.toLowerCase()) {
    case 'gaelic football':
      return <MdSports className="h-5 w-5 mr-2 inline-block" />;
    case 'hurling':
    case 'camogie':
      return <Circle className="h-5 w-5 mr-2 inline-block" />;
    case 'rugby':
      return <MdSportsRugby className="h-5 w-5 mr-2 inline-block" />;
    case 'soccer':
      return <MdSportsSoccer className="h-5 w-5 mr-2 inline-block" />;
    case 'hockey':
      return <MdSportsHockey className="h-5 w-5 mr-2 inline-block" />;
    case 'basketball':
      return <MdSportsBasketball className="h-5 w-5 mr-2 inline-block" />;
    default:
      return <MdSports className="h-5 w-5 mr-2 inline-block" />;
  }
};

const TruncatedTeamsList = ({ teams }) => {
  if (!teams || teams.length === 0 || !teams[0]) return <span>Unassigned</span>;
  
  const team = teams[0];
  return (
    <span title={teams.map(t => `${t.sport || 'Unknown'} (${t.team_category || 'Unknown'})`).join(', ')}>
      {getTeamIcon(team.sport)}
      <span className="align-middle">{team.team_name || 'Unnamed Team'}</span>
      {teams.length > 1 && <span className="text-gray-500 ml-1">+{teams.length - 1} more</span>}
    </span>
  );
};

export default TruncatedTeamsList;